var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center"},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('img',_vm._g({attrs:{"src":_vm.url,"width":_vm.width,"height":_vm.width/1.5}},on))]}}])},[_c('span',[_vm._v(_vm._s(_vm.name))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }